import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ExpensiveItemsList').create(({theme}) => ({
  root: {
    maxWidth: '100vw',
    // paddingLeft: '16px',
    // paddingTop: '16px',
    display: 'flex',
    // overflowX: 'scroll',
    
  },

  itemContainer: {
    display: 'flex',
    aspectRatio: '1/1',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.sizes.radiuses.m,
    border: '1px solid',
    borderColor: 'rgba(255, 255, 255, 0.50)',


    img: {
        width: '90%',
        alignSelf: 'center'
    }
  },
}))  